import { render, staticRenderFns } from "./PanelCard.vue?vue&type=template&id=1447c209&"
import script from "./PanelCard.vue?vue&type=script&lang=js&"
export * from "./PanelCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports